<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="30">
                        <el-col><span class="color-info">最近更新时间: </span>{{formData.updateTime}}</el-col>
                        <el-col><span class="color-info">审核状态: </span>{{status.get(formData.status)}}</el-col>
                        <el-col><span class="color-info">寄送状态: </span>{{sendStatus.get(formData.sendStatus)}}</el-col>
                    </el-row>
                    <el-row :gutter="30" class="MT10">
                        <el-col><span class="color-info">发出时间: </span>{{formData.sendTime}}</el-col>
                        <el-col><span class="color-info">快递公司: </span>{{formData.mailCompany}}</el-col>
                        <el-col><span class="color-info">运单号: </span>{{formData.mailNo}}</el-col>
                        <el-col><span class="color-info">寄回时间: </span>{{formData.backTime}}</el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        formData:{
            type: Object,
            default: null
        }
    },
    data(){
        return{}
    },
    computed:{
        status(){
            return new Map([
                [1,'待审核'],
                [2,'已通过'],
                [3,'已拒绝'],
                [4,'已撤销'],
                [99,'已过期']
            ])
        },
        sendStatus(){
            return new Map([
                [1,'待发出'],
                [2,'已发出'],
                [3,'已寄回'],
            ])
        }
    }
}
</script>